<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.112.112h19.776v19.776H.112V.112z" />
    <path
      d="M21.2598271 9.44779712 12.6725124.88879783c-.1227139-.12182899-.3054775-.15702224-.467648-.09266886-.160441.0669275-.2642913.22310511-.2642913.3964168V5.9117801H1.21503693C.9782165 5.91182032.786001 6.10399559.786001 6.34081603v6.86437377c0 .2368204.1922155.4290359.42903593.4290359H11.9406134v4.7012154c0 .1733117.1046949.3294893.2651359.3964168.0532122.0223226.1089583.0326191.1639.0326191.1115324 0 .2213756-.0437603.3037479-.125288l8.5873148-8.58389599c.0806428-.08064283.125288-.18964136.125288-.30374794 0-.11410659-.04553-.2230649-.1261729-.30374795Z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
